import { jsx } from "react/jsx-runtime";
import { c } from "react/compiler-runtime";
import { Field } from "react-final-form";
import { RadioInputComplexLabel } from "@vk-hr-tek/ui/input";
import { composeValidators } from "../validation/index.js";
function _define_property(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if ("function" == typeof Object.getOwnPropertySymbols) ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function RadioInputComplexLabel_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = null != source ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else RadioInputComplexLabel_ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
    return target;
}
function _object_without_properties(source, excluded) {
    if (null == source) return {};
    var target = {}, sourceKeys, key, i;
    if ("u" > typeof Reflect && Reflect.ownKeys) {
        sourceKeys = Reflect.ownKeys(Object(source));
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (!(excluded.indexOf(key) >= 0)) {
                if (Object.prototype.propertyIsEnumerable.call(source, key)) target[key] = source[key];
            }
        }
        return target;
    }
    target = _object_without_properties_loose(source, excluded);
    if (Object.getOwnPropertySymbols) {
        sourceKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (!(excluded.indexOf(key) >= 0)) {
                if (Object.prototype.propertyIsEnumerable.call(source, key)) target[key] = source[key];
            }
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (null == source) return {};
    var target = {}, sourceKeys = Object.getOwnPropertyNames(source), key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (!(excluded.indexOf(key) >= 0)) {
            if (Object.prototype.propertyIsEnumerable.call(source, key)) target[key] = source[key];
        }
    }
    return target;
}
const handleChange = (input, onChange)=>(value)=>{
        input.onChange(value);
        if (onChange) onChange(value);
    };
const RadioInputComplexLabel_RadioInputComplexLabel = (t0)=>{
    const $ = c(32);
    let allowClear;
    let defaultValue;
    let label;
    let name;
    let onChange;
    let options;
    let render;
    let renderFooter;
    let required;
    let rest;
    let t1;
    let t2;
    if ($[0] !== t0) {
        ({ name, onChange, options, defaultValue, renderFooter, render, variant: t1, label, required, allowClear, validateArray: t2 } = t0), rest = _object_without_properties(t0, [
            "name",
            "onChange",
            "options",
            "defaultValue",
            "renderFooter",
            "render",
            "variant",
            "label",
            "required",
            "allowClear",
            "validateArray"
        ]);
        $[0] = t0;
        $[1] = allowClear;
        $[2] = defaultValue;
        $[3] = label;
        $[4] = name;
        $[5] = onChange;
        $[6] = options;
        $[7] = render;
        $[8] = renderFooter;
        $[9] = required;
        $[10] = rest;
        $[11] = t1;
        $[12] = t2;
    } else {
        allowClear = $[1];
        defaultValue = $[2];
        label = $[3];
        name = $[4];
        onChange = $[5];
        options = $[6];
        render = $[7];
        renderFooter = $[8];
        required = $[9];
        rest = $[10];
        t1 = $[11];
        t2 = $[12];
    }
    const variant = void 0 === t1 ? "primary" : t1;
    let t3;
    if ($[13] !== t2) {
        t3 = void 0 === t2 ? [] : t2;
        $[13] = t2;
        $[14] = t3;
    } else t3 = $[14];
    const validateArray = t3;
    if (!options || !options.length) return null;
    let t4;
    if ($[15] !== validateArray) {
        t4 = composeValidators(validateArray);
        $[15] = validateArray;
        $[16] = t4;
    } else t4 = $[16];
    let t5;
    if ($[17] !== allowClear || $[18] !== label || $[19] !== onChange || $[20] !== options || $[21] !== render || $[22] !== renderFooter || $[23] !== required || $[24] !== variant) {
        t5 = (t6)=>{
            const { input } = t6;
            return /*#__PURE__*/ jsx(RadioInputComplexLabel, _object_spread_props(_object_spread({}, input), {
                items: options,
                onChange: handleChange(input, onChange),
                render: render,
                renderFooter: renderFooter,
                variant: variant,
                label: label,
                required: required,
                allowClear: allowClear
            }));
        };
        $[17] = allowClear;
        $[18] = label;
        $[19] = onChange;
        $[20] = options;
        $[21] = render;
        $[22] = renderFooter;
        $[23] = required;
        $[24] = variant;
        $[25] = t5;
    } else t5 = $[25];
    let t6;
    if ($[26] !== defaultValue || $[27] !== name || $[28] !== rest || $[29] !== t4 || $[30] !== t5) {
        t6 = /*#__PURE__*/ jsx(Field, _object_spread_props(_object_spread({
            name: name,
            initialValue: defaultValue,
            validate: t4
        }, rest), {
            children: t5
        }));
        $[26] = defaultValue;
        $[27] = name;
        $[28] = rest;
        $[29] = t4;
        $[30] = t5;
        $[31] = t6;
    } else t6 = $[31];
    return t6;
};
export { RadioInputComplexLabel_RadioInputComplexLabel as RadioInputComplexLabel };
